module.exports = __webpack_public_path__ + "static/media/kathryn_frederick.483d5e5c.png";